import React from 'react';
import Modal from '../../components/Modal';
import './FirstTimeModal.less';
import Image from '../../components/Image';

function FirstTimeModal() {
  const [isOpen, setIsOpen] = React.useState(true);

  const close = () => {
    setIsOpen(false);
  }

  return (
    <Modal className="firstTimeModal" open={isOpen} onClose={close}>
      <div className="backgroundImage">
        <Image
          src="https://cdn.education.com/files/static/paywallModel/mascots-background.png"
          alt="Mascots"
          className="mascots"
        />
      </div>
      <div className="textSection">
        <h3 className="firstTimeHeader">First time here?</h3>
        <div className="firstTimeBody">
          <strong>Education.com</strong> is the world’s largest collection
          of educational worksheets, games, videos, and songs.
        </div>
        <div className="dividerSection">
          <div className="dividingLine" />
          <div className="gradeRange">Pre-K through 8th grade</div>
          <div className="dividingLine" />
        </div>
      </div>
      <div className="buttonContainer">
        <button className="btn btn-primary react-signup" type="button" onClick={close}>Create account</button>
        <button className="btn btn-secondary" type="button" onClick={close}>Keep exploring</button>
      </div>
    </Modal>
  );
}

export default FirstTimeModal;
